import React from 'react';
import tick from '../../../images/icon/tick-square.svg';

const NpiMarketingBanner = ({ title, topic, image }) => {
  return (
    <div className="mt-[100px] lg:mt-[180px] pb-[40px] lg:pb-[80px]">
      <div className="container inner-content">
        <div className="row align-items-center justify-content-between banner-hero-container">
          <div className="col-lg-7 col-md-9 col-sm-12">
            <h1 color="text-[30px] lg:text-[50px]">{title}</h1>
            <h3 className="title-ext text-primary">{topic}</h3>
            <p
              className="lh-base"
              style={{
                fontWeight: '400',
                color: 'var($primary)',
              }}
            >
              Every licensed clinician in the U.S. has an NPI (National Provider
              Identifier) that includes specialty, practice setting, and
              affiliation data. By using this registry as the foundation for
              digital outreach, recruitment teams can now: 
            </p>
            <div>
              <p className="flex gap-[10px]">
                {' '}
                <img src={tick} alt="" />
                <span>
                  Target physicians and APPs by specialty, subspecialty, and
                  geography
                </span>
              </p>
              <p className="flex gap-[10px]">
                {' '}
                <img src={tick} alt="" />
                <span>
                  Deliver ads to those clinicians directly across their devices
                </span>
              </p>
              <p className="flex gap-[10px]">
                {' '}
                <img src={tick} alt="" />
                <span>
                  Receive detailed reports on who viewed and clicked with name,
                  role, and timestamped interest
                </span>
              </p>
            </div>
            <p>
              This method turns passive outreach into a measurable, repeatable
              campaign supporting your internal team without relying solely on
              third-party recruiters.
            </p>
          </div>

          <div className="col-lg-5 col-md-6 col-sm-12">
            <div
              className="banner-img"
              style={{
                marginLeft: 'auto',
              }}
            >
              <img
                src={image}
                style={{
                  width: '100%',
                  objectFit: 'contain',
                  borderRadius: '10px',
                }}
                alt=""
              />
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default NpiMarketingBanner;
